import React, { useContext } from "react";
import Term, { filterTerms } from "../Term";
import { GenresContext } from "./ShopArchive";

export type ShopData = {
  id: number;
  genre: number[];
  title: { rendered: string };
  content: { rendered: string };
  shop_meta: {
    first_image_url: string;
    "shop-image": string;
  };
  slug: string;
};

const Shop: React.FC<{
  shop: ShopData;
}> = ({ shop }) => {
  const genres = useContext(GenresContext);

  const handleBoxClick = () => {
    window.location.href = `/shop/${shop.slug}`;
  };

  return (
    <>
      <div className="shop" onClick={() => handleBoxClick()}>
        <div className="shop__image-wrapper">
          <img
            className="shop__image"
            src={shop.shop_meta.first_image_url.toString()}
          />
        </div>
        <div className="shop__content-wrapper">
          <div className="term">
            {filterTerms(shop.genre, genres).map((genre) => (
              <Term key={genre.id} term={genre} />
            ))}
          </div>
          <h2
            className="shop__title"
            dangerouslySetInnerHTML={{ __html: shop.title.rendered }}
          ></h2>
          <div
            className="shop__content"
            dangerouslySetInnerHTML={{ __html: shop.content.rendered }}
          ></div>
        </div>
      </div>
    </>
  );
};

export default Shop;
